import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Sticky plan panel — pinned above the chat scroll area, shows the current
// TodoWrite state. Collapses to a one-line summary when there are >5 items;
// click the header to expand. Auto-hides when there are zero todos OR when
// every item is completed (cleaner UX — once the work is done there's no
// reason for a static "all green" widget to keep occupying chrome).
import { useState } from "react";
const ICON = {
    completed: "✓",
    in_progress: "•",
    pending: "○",
};
const COLOR = {
    completed: "text-success",
    in_progress: "text-accent",
    pending: "text-muted",
};
export default function PlanPanel({ items }) {
    // Default: collapsed if the list is long. User can toggle.
    const [open, setOpen] = useState(null);
    if (!items || items.length === 0)
        return null;
    const done = items.filter((t) => t.status === "completed").length;
    const inProgress = items.filter((t) => t.status === "in_progress").length;
    const pending = items.filter((t) => t.status === "pending").length;
    // Hide once the plan is fully done. The events log still keeps every
    // todo_update for replay; this is a pure presentation choice so the
    // chrome doesn't carry a stale "all green" widget after the work is over.
    // The panel reappears automatically if the agent emits a new TodoWrite
    // (e.g. starting a follow-up phase).
    if (done === items.length)
        return null;
    // If the user hasn't toggled, default to expanded for small lists.
    const expanded = open == null ? items.length <= 5 : open;
    return (_jsxs("div", { className: "border-b border-border/70 bg-elevated/60 backdrop-blur-md", children: [_jsxs("button", { type: "button", onClick: () => setOpen(!expanded), className: "flex w-full items-center justify-between px-4 py-2 text-left transition-colors hover:bg-surface/60", children: [_jsxs("div", { className: "flex items-center gap-3 text-sm", children: [_jsx("span", { className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-muted", children: "Plan" }), _jsxs("span", { className: "text-success", children: [done, " done"] }), inProgress > 0 && (_jsxs("span", { className: "text-accent", children: [inProgress, " in progress"] })), pending > 0 && (_jsxs("span", { className: "text-muted", children: [pending, " pending"] }))] }), _jsx("span", { className: "text-muted", children: expanded ? "▾" : "▸" })] }), expanded && (_jsx("ul", { className: "space-y-0.5 px-4 pb-3", children: items.map((t, i) => (_jsxs("li", { className: "flex items-baseline gap-2 text-sm", children: [_jsx("span", { className: `${COLOR[t.status]} w-3`, children: ICON[t.status] }), _jsx("span", { className: t.status === "completed"
                                ? "text-muted line-through"
                                : t.status === "in_progress"
                                    ? "text-text"
                                    : "text-muted", children: t.status === "in_progress" ? t.activeForm : t.content })] }, `${i}-${t.content}`))) }))] }));
}
